// 站点地图-关于我们
<template>
  <div>
    <!-- <Header /> -->
    <Logo></Logo>
    <Tabs class="tabs"></Tabs>
    <!-- <div style="height:5.125rem;"><Tabbar></Tabbar></div> -->
  </div>
</template>

<script>
// import Header from '../../common/FirstHeader.vue'
import Logo from "../Index/Index_components/logo.vue"
import Tabs from './map_components/tabs.vue'
import Tabbar from '../Index/Index_components/Tabbar.vue'
import api from '@/utils/api'
export default {
  components: {
    Tabs,
    // Header,
    Logo,
    Tabbar,
  },
  methods: {},
}
</script>

<style scoped>
.tabs {
  margin-top: 1rem;
}
</style>
